import dayjs from 'dayjs'
import type { DateRange } from '../types'
import { CUSTOM, PERIODS } from '../constants'

export const daysOf = (period: string): number =>
  PERIODS.find((p) => p.value === period)?.days ?? 0

export const presetRange = (period: string): DateRange => {
  const days = daysOf(period)
  return [days ? dayjs().subtract(days, 'day') : null, null]
}

/** Garante que o range cubra o dia inteiro (00:00 até 23:59:59) */
export const expandToFullDayRange = ([from, to]: DateRange): DateRange => [
  from?.startOf('day') ?? null,
  to?.endOf('day') ?? null,
]

export const resolvePeriod = (activePeriod: unknown, hasDates: boolean): string => {
  if (typeof activePeriod === 'string' && activePeriod) return activePeriod
  return hasDates ? CUSTOM : ''
}
